module.exports = __webpack_public_path__ + "img/lita-ari.71e4e3dc.png";